import { useState } from 'react';
import { BlacklistUserInfoAdditionalSegment } from './types';
import AdditionalSegmentRecord from './additional-segment-record';
import IconUp from '../../icons/up';
import IconDown from '../../icons/down';

import cn from './blacklist.module.css';

const AdditionalSegment = ({
  segment,
  title,
}: BlacklistUserInfoAdditionalSegment) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className={cn.additionalSegmentWrapper}>
      <button
        type="button"
        className={cn.additionalSegmentButton}
        onClick={() => setExpanded(!expanded)}
      >
        {title}
        <div className={cn.additionalSegmentButtonIcon}>
          {expanded ? (
            <IconUp width={14} height={14} />
          ) : (
            <IconDown width={14} height={14} />
          )}
        </div>
      </button>
      {expanded &&
        segment?.map((item, index) => (
          <AdditionalSegmentRecord
            key={item.segmentGUID}
            record={item}
            index={index + 1}
            segmentId={item?.segmentGUID}
          />
        ))}
    </div>
  );
};

export default AdditionalSegment;
